import Alpine from 'alpinejs';

Alpine.directive('trim', (el, { }, { effect }) => {
    effect(() => {
        el.addEventListener('input', () => {
            el.value = el.value.trim();
        });
    })
})
